module.exports = __webpack_public_path__ + "static/img/shopOperationbj.06d5a5da.png";